import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import taskPanelReducerGenerator from '../reducerGenerator'
import assignmentsReducerGenerator from '../../usersAssignedToHierarchy/reducerGenerator'

const createNewTaskPanelReducer = (initAppData) => {

    const panelReducer = taskPanelReducerGenerator({
        actionTypes: ActionTypes,
    })

    const assignmentsReducer = assignmentsReducerGenerator({
        actionTypes: {
            ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
            ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
            CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET,
            CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET,
        }
    })

    const initialState = {
        ...panelReducer.initialState,
        ...assignmentsReducer.initialState,
        addedAssignedUserIds: {},
        addedAssignedManagerIds: {},

        taskInfoDefaultState: {
            workflowStatusId: 0,
            creationTimestamp: null,
            completed: false,
            name: '',
            deadline: null,
            typeOfWorkId: 0,
            estimatedTime: null,
            spentTime: 0,
            description: '',
        },

        customFieldsValues: {}
    }

    return handleActions({
        ...panelReducer.handlers,
        ...assignmentsReducer.handlers,

        [ActionTypes.ADDED_ASSIGNED_USER_IDS_SET]: (state, {payload: addedAssignedUserIds}) => ({...state, addedAssignedUserIds}),
        [ActionTypes.ADDED_ASSIGNED_MANAGER_IDS_SET]: (state, {payload: addedAssignedManagerIds}) => ({...state, addedAssignedManagerIds}),
        [ActionTypes.CREATE_PANEL_STATE_RESET]: (state) => ({
            ...state,
            ...panelReducer.initialState,
            customFieldsValues: {},
        }),
        [ActionTypes.TASK_DATA_DEFAULT_STATE_PROPERTY_SET]: (state, {payload: changedProperties}) => ({
            ...state,
            taskInfoDefaultState: {
                ...state.taskInfoDefaultState,
                ...changedProperties,
            }
        }),
        [ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE]: (state, {payload: customValuesDiff}) => ({
            ...state,
            customFieldsValues: {
                ...state.customFieldsValues,
                ...customValuesDiff
            }
        })
    }, initialState)
}

export default createNewTaskPanelReducer


// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/reducer.js